export const URL_TOP = "/simulation";
export const URL_SIMULATE = URL_TOP + "/simulate";
export const URL_PREVIEW = URL_TOP + "/zpl-viewer";
